<template>
  <div id="automaticMarking" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      <el-breadcrumb-item>自动打标</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="产品信息" :label-width="formLabelWidth">
            <el-cascader
              filterable
              clearable
              size="small"
              v-model="productid"
              :options="options2"
              :props="productidChildren"
              collapse-tags
              @change="handleChange"
              @visible-change="getListBybmcid"
              style="width: 100%;"
              :disabled="cascaderDisabled"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="关键字" :label-width="formLabelWidth">
            <el-input v-model="key" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="seletAutoProductPage()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="page2">
      <el-button size="small" type="primary" style="margin-right: 8px;" @click="newAdd()">新增</el-button>
      <el-button size="small" style="margin-right: 8px;" @click="deleteChange(2)">批量删除</el-button>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{allTotle}}</span>项,已选择<span class="promptFont">{{checktotle}}</span>项
        <span class="promptFont2" @click="toggleSelection(tableData,true)">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>

      <el-table ref="multipleTable" :data="tableData" style="width: 100%;margin-top: 5px;" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" @selection-change="handleSelectionChange">>
        <el-table-column type="selection" width="60">
        </el-table-column>
        <el-table-column label="序号" width="120">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="productname" label="产品名称">
        </el-table-column>
        <el-table-column label="关键字">
          <template slot-scope="scope">
            <span v-if="scope.row.childList && scope.row.childList.length > 0">
              <span v-if="scope.row.childList[0].autovalue">
                {{scope.row.childList[0].autovalue}}
              </span>
              <span v-if="scope.row.childList[0].alias">
                {{scope.row.childList[0].alias}}
              </span>
            </span>
            <el-button type="primary" @click="editorClick(2,scope.row)" size="mini" v-if="scope.row.childList && scope.row.childList.length > 1" style="margin-left: 10px;">关键字列表</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="editorClick(1,scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteChange(1,scope.row.productid)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
      <el-dialog
        :visible.sync="visible"
        :close-on-click-modal="false"
        title="新增"
        width="960px"
        id="childMonitoring"
        >
        <el-radio v-model="radio" label="1" style="margin: 10px 20px 10px 0;">单个新增</el-radio>
        <el-radio v-model="radio" label="2">批量新增</el-radio>
        <div v-if="radio == '1'">
          <el-form class="search-form" style="margin-left: -30px;margin-top: 16px;">
            <el-form-item label="产品名称" :label-width="formLabelWidth" :required="true">
              <el-cascader
                filterable
                clearable
                size="small"
                v-model="productid2"
                :options="options2"
                :props="productidChildren2"
                collapse-tags
                @change="handleChange2"
                @visible-change="getListBybmcid"
                style="width: 440px;"
                :disabled="cascaderDisabled"
              ></el-cascader>
            </el-form-item>
          </el-form>
          <div style="overflow: hidden;">
            <div style="width: 100%;">
              <div style="margin-left: 70px;float: left;">
                关键字
              </div>
              <div style="margin-left: 120px;float: left;">
                别名
              </div>
            </div>
            <div style="clear: both;margin-bottom: 10px;display: flex;" v-for="(item,index) in newData">
              <div style="color: rgb(245, 108, 108);margin-left: 60px;width: 10px;float: left;line-height: 63px;">
                *
              </div>
              <div class="marginStyle" style="margin-right: 8px;">
                <el-input v-model="item.autovalue" placeholder="请输入内容" size="small"></el-input>
              </div>
              <div class="marginStyle">
                <el-input v-model="item.alias" placeholder="请输入内容" size="small"></el-input>
              </div>
              <div style="width: 150px;float: left;margin-top: 16px;margin-bottom: 10px;">
                <i class="el-icon-remove-outline" style="cursor: pointer;height: 32px;line-height: 32px;margin-left: 10px;color: #409eff;" @click="delIcon(index)"></i>
              </div>
            </div>
            <div class="buttonStyle" @click="newAddIcon">
              <i class="el-icon-plus">新增</i>
            </div>


            <div style="clear: both;">
              <div style="margin-left: 70px;float: left;margin-top: 16px;">
                SKU关键字
              </div>
              <div style="margin-left: 90px;float: left;margin-top: 16px;">
                SKU别名
              </div>
            </div>
            <div style="clear: both;margin-left: 70px;margin-bottom: 10px;" v-for="(item,index) in newSkuData">
              <div class="marginStyle" style="margin-right: 8px;">
                <el-input v-model="item.autovalue" placeholder="请输入内容" size="small"></el-input>
              </div>
              <div class="marginStyle">
                <el-input v-model="item.alias" placeholder="请输入内容" size="small"></el-input>
              </div>
              <div style="width: 150px;float: left;margin-top: 16px;margin-bottom: 10px;">
                <i class="el-icon-remove-outline" style="cursor: pointer;height: 32px;line-height: 32px;margin-left: 10px;color: #409eff;" @click="delSkuIcon(index)"></i>
              </div>
            </div>
            <div class="buttonStyle" @click="newSkuIcon">
              <i class="el-icon-plus">新增</i>
            </div>
          </div>
        </div>

        <div class="divBor" v-if="radio == '2'">
          <div class="allDiv">
            <div class="header">选择产品</div>
            <div style="height: 525px;overflow-y: auto;">
              <div v-for="(item,index) in treeData" style="line-height: 24px;">
                <span @click="getPageBybmcid(item,index,1)" style="margin-left: 6px;cursor: pointer;">
                  <i :class="item.elIcon"></i>
                  {{item.productClassifyName}}
                </span>
                <el-button type="text" style="margin-left: 6px;" @click="allChange(index,item.childData,1,item.fieldvalue)" v-if="item.childData.length != item.checkList.length && item.elIcon == 'el-icon-caret-bottom' && item.fieldvalue">全选</el-button>
                <el-button type="text" @click="allChange(index,item.childData,2,item.fieldvalue)" v-if="item.childData.length == item.checkList.length && item.elIcon == 'el-icon-caret-bottom' && item.fieldvalue">取消全选</el-button>
                <div style="margin-top: 10px;">
                  <el-select v-model="item.fieldvalue" placeholder="请优先选择关键字品名" size="mini" v-if="item.elIcon == 'el-icon-caret-bottom'" style="margin-left: 24px;margin-bottom: 10px;" @change="fieldChange(index,item.fieldvalue)">
                    <el-option
                      v-for="a in item.options"
                      :key="a.fieldvalue"
                      :label="a.fieldname"
                      :value="a.fieldvalue">
                    </el-option>
                  </el-select>
                </div>
                <el-checkbox-group v-model="item.checkList" v-for="i in item.childData" v-if="item.elIcon == 'el-icon-caret-bottom' && item.fieldvalue" style="margin-left: 25px;line-height: 24px;">
                  <el-checkbox :label="i.allProductName" @change="chooseAlone(i,item.fieldvalue)"></el-checkbox>
                </el-checkbox-group>

                <div v-if="item.childData.length == 0 && item.elIcon == 'el-icon-caret-bottom'"
                  style="color: rgb(204, 204, 204);margin-left: 24px;height: 30px;"
                  v-loading="divLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
                  暂无数据
                </div>
                <div>
                  <el-button style="margin-left: 22px;" type="text" @click="addMore(index,item.childData,item.pageSize,item)" v-if="item.addMoreShow">更多</el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="smDiv">
            <div class="header">
              已选字段
            </div>
            <div style="height: 525px;overflow-y: auto;">
              <div v-for="(item,index) in selectedData" class="selSty">
                <el-tooltip class="item" effect="dark" :content="item.name" placement="top" v-if="item.name.length > 35">
                  <div class="ellipsisFont">
                    {{item.name}}
                  </div>
                </el-tooltip>
                <div class="ellipsisFont" v-else>
                  {{item.name}}
                </div>
                <div style="float: right;">
                  <i class="el-icon-circle-close" style="cursor: pointer;" @click="del(index,item.smallName)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer">
          <el-button size="small" @click="insert" type="primary" style="margin-right: 8px;" v-if="radio == '1'">确 定</el-button>
          <el-button size="small" @click="visible = false" type="TheCustom" v-if="radio == '1'">取 消</el-button>

          <el-button size="small" @click="insertByProduct" type="primary" style="margin-right: 8px;" v-if="radio == '2'">确 定</el-button>
          <el-button size="small" @click="visible = false" type="TheCustom" v-if="radio == '2'">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 批量删除 -->
    <el-dialog :visible.sync="deleteShow" width="360px" style="margin-top: 10%;" title="提示" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
          <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
         <div>
             <div style="font-size: 16px;">你确认要删除{{valLength}}自动打标信息吗？</div>
             <div style="font-size: 14px;">删除后
             <span style="color: #e90e24;font-size: 14px;">自动打标信息将无法找回</span>
          </div>
         </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteByBmcid()" size="small" :loading="allDelLoading">确 定</el-button>
        <el-button @click="deleteShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量删除 -->
    <!-- 编辑 -->
    <el-dialog :visible.sync="editorShow" width="840px" style="margin-top: 10%;" title="编辑" id="dialog">
      <div style="overflow: hidden;">
        <div style="padding-left: 26px;margin-bottom: 16px;">
          产品名称：
          <el-input v-model="productname" disabled size="small" style="width: 440px;"></el-input>
        </div>

        <div style="width: 100%;">
          <div style="margin-left: 70px;float: left;">
            关键字
          </div>
          <div style="margin-left: 120px;float: left;">
            别名
          </div>
        </div>
        <div style="clear: both;margin-bottom: 10px;display: flex;" v-for="(item,index) in newData">
          <div style="color: rgb(245, 108, 108);margin-left: 60px;width: 10px;float: left;line-height: 63px;">
            *
          </div>
          <div class="marginStyle" style="margin-right: 8px;">
            <el-input v-model="item.autovalue" placeholder="请输入内容" size="small"></el-input>
          </div>
          <div class="marginStyle">
            <el-input v-model="item.alias" placeholder="请输入内容" size="small"></el-input>
          </div>
          <div style="width: 150px;float: left;margin-top: 16px;margin-bottom: 10px;">
            <i class="el-icon-remove-outline" style="cursor: pointer;height: 32px;line-height: 32px;margin-left: 10px;color: #409eff;" @click="delIcon(index)"></i>
          </div>
        </div>
        <div class="buttonStyle" @click="newAddIcon">
          <i class="el-icon-plus">新增</i>
        </div>

        <div style="clear: both;">
          <div style="width: 100%;">
            <div style="margin-left: 70px;float: left;margin-top: 16px;">
              SKU关键字
            </div>
            <div style="margin-left: 120px;float: left;margin-top: 16px;">
              SKU别名
            </div>
          </div>
        </div>
        <div style="clear: both;margin-left: 70px;margin-bottom: 10px;" v-for="(item,index) in newSkuData">
          <div class="marginStyle" style="margin-right: 8px;">
            <el-input v-model="item.autovalue" placeholder="请输入内容" size="small"></el-input>
          </div>
          <div class="marginStyle">
            <el-input v-model="item.alias" placeholder="请输入内容" size="small"></el-input>
          </div>
          <div style="width: 150px;float: left;margin-top: 16px;margin-bottom: 10px;">
            <i class="el-icon-remove-outline" style="cursor: pointer;height: 32px;line-height: 32px;margin-left: 10px;color: #409eff;" @click="delSkuIcon(index)"></i>
          </div>
        </div>
        <div class="buttonStyle" @click="newSkuIcon">
          <i class="el-icon-plus">新增</i>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="update()" size="small" :loading="allDelLoading">确 定</el-button>
        <el-button @click="editorShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑 -->
    <!-- 查看关键字 -->
    <el-dialog :visible.sync="keywordShow" width="840px" style="margin-top: 10%;" title="关键字列表" id="dialog">
      <div style="overflow: hidden;">
        <div style="width: 100%;background-color: #f3f7ff;height: 40px;line-height: 40px;">
          <div style="width: 50%;float: left;">
            关键字
          </div>
          <div style="width: 50%;float: left;">
            别名1
          </div>
        </div>
        <div style="width: 100%;border-bottom: 1px solid #EBEEF5;height: 40px;line-height: 40px;" v-for="item in newData">
          <div style="height: 30px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width: 50%;float: left;">
            {{item.autovalue}}
          </div>
          <div style="height: 30px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width: 50%;float: left;">
            {{item.alias}}
          </div>
        </div>
        <div style="width: 100%;background-color: #f3f7ff;height: 40px;line-height: 40px;">
          <div style="width: 50%;float: left;">
            SKU关键字
          </div>
          <div style="width: 50%;float: left;">
            SKU别名
          </div>
        </div>
        <div style="width: 100%;border-bottom: 1px solid #EBEEF5;height: 40px;line-height: 40px;" v-for="item in newSkuData">
          <div style="height: 30px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width: 50%;float: left;">
            {{item.autovalue}}
          </div>
          <div style="height: 30px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width: 50%;float: left;">
            {{item.alias}}
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="keywordShow = false" style="margin-left: 10px;" size="small" type="TheCustom">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 查看关键字 -->
  </div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  import axios from "axios";
  export default {
    data() {
      return {
        newData:[{
          type: 1,
          alias: "",
          autovalue: "",
          productid: "",
        }],
        newSkuData:[{
          type: 2,
          alias: "",
          autovalue: "",
          productid: "",
        }],
        keywordShow: false,
        editorShow: false,
        productname: '',
        deleteShow: false,
        allDelLoading: false,
        radio: '1',
        productidChildren: {
          // multiple: true,
          value: "id",
          label: "productClassifyName",
          children: "children"
        },
        productidChildren2: {
          value: "id",
          label: "productClassifyName",
          children: "children"
        },
        productid2: "",
        options2: [],
        productid: "",
        formLabelWidth: "100px",
        tableData: [],
        tableLoading: false,
        bigPageNum: 1,
        bigPageSize: 10,
        pageNum: 1,
        pageSize: 10,
        currentPage: 1,
        totalNum: 10,
        cascaderDisabled: false,
        checkALL: false,
        checktotle: 0,
        allTotle: 0,
        key: "",
        treeData: [],
        selectedData: [],
        visible: false,
        options: [],
        classifyid: '',
        deleteId: '',
        valLength: '',
        deleteType: 1,
      }
    },
    mounted() {
      this.seletAutoProductPage()
    },
    methods: {
      // 关键字新增
      newAddIcon() {
        this.newData.push({
          type: 1,
          alias: "",
          autovalue: "",
          productid: "",
        })
      },
      delIcon(e) {
        if (this.newData.length == 1) {
          this.$message({
            message: '最少保留一项',
            type: 'warning'
          });
          return
        } else {
          this.newData.splice(e,1)
        }
      },
      // sku关键字新增
      newSkuIcon() {
        this.newSkuData.push({
          type: 2,
          alias: "",
          autovalue: "",
          productid: "",
        })
      },
      delSkuIcon(e) {
        if (this.newSkuData.length == 1) {
          this.$message({
            message: '最少保留一项',
            type: 'warning'
          });
          return
        } else {
          this.newSkuData.splice(e,1)
        }
      },
      // 编辑
      update() {
        let hcmProductAuto = {
          childList: [],
          productid: this.editorProductid,
          productname: this.productname,
        }
        if (this.newData && this.newData.length != 0) {
          for (let a in this.newData) {
            this.newData[a].productid = this.editorProductid
            hcmProductAuto.childList.push(this.newData[a])
          }
        }
        if (this.newSkuData && this.newSkuData.length != 0) {
          for (let b in this.newSkuData) {
            if (this.newSkuData[b].alias || this.newSkuData[b].autovalue) {
              this.newSkuData[b].productid = this.editorProductid
              hcmProductAuto.childList.push(this.newSkuData[b])
            }
          }
        }
        for (let c in hcmProductAuto.childList) {
          if (!hcmProductAuto.childList[c].autovalue && hcmProductAuto.childList[c].type != 2) {
            this.$message({
              message: '请填写正确的数据',
              type: 'warning'
            });
            return
          }
        }
        let that = this
        axios({
           method: 'post',
           url: 'hcm/HcmProductAuto/update',
           headers: {
             'Content-type': 'application/json;charset=UTF-8'
           },
           data: hcmProductAuto,
           timeout: 60 * 1000 * 50
        }).then(function (response) {
          if (response.data.status == "10000") {
            that.$message({
              message: '保存成功',
              type: 'success'
            });
            that.editorShow = false
            that.allDelLoading = false
            that.seletAutoProductPage()
          } else {
            that.$message.error(response.data.message)
          }
        })
      },
      // 编辑数据处理
      editorClick(e,data) {
        this.newSkuData = []
        this.newData = []
        if (data.childList.length != 0) {
          for (let a in data.childList) {
            if (data.childList[a].type == '1') {
              this.newData.push({
                type: 1,
                alias: data.childList[a].alias,
                autovalue: data.childList[a].autovalue,
                productid: '',
              })
            } else {
              this.newSkuData.push({
                type: 2,
                alias: data.childList[a].alias,
                autovalue: data.childList[a].autovalue,
                productid: '',
              })
            }
          }
        }
        if (this.newSkuData.length == 0) {
          this.newSkuData.push({
            type: 2,
            alias: '',
            autovalue: '',
            productid: '',
          })
        }
        this.editorProductid = data.productid
        this.productname = data.productname
        if (e == 1) {
          this.editorShow = true
        } else {
          this.keywordShow = true
        }
      },
      deleteChange(e,productid) {
        this.deleteType = e
        if (e == 1) {
          this.checkALL = false
          this.deleteId = productid
          this.valLength = '该条'
        } else {
          if (this.checktotle == 0) {
            this.$message({
              message: '没有选中项',
              type: 'warning'
            });
            return
          }
        }
        this.deleteShow = true
      },
      // table方法
      toggleSelection(rows, all) {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleAllSelection(row);
          });
        } else {
          this.checkALL = false;
          this.$refs.multipleTable.clearSelection();
        }
        if (all && all == true) {
          this.checkALL = true;
          this.valLength = '全部'
          this.allTotle = this.totalNum
          this.checktotle = this.totalNum
        }
      },
      // table方法
      handleSelectionChange(val) {
        this.multipleSelection = val;
        if (this.checkALL != true) {
          this.checktotle = this.multipleSelection.length
          this.valLength = this.multipleSelection.length + '条'
        } else {
          this.valLength = '全部'
        }
      },
      // 确认删除
      deleteByBmcid() {
        if (this.checkALL) {
          this.deleteId = 'checkAll'
        } else {
          if (this.multipleSelection && this.deleteType == 2) {
            let arr = []
            this.multipleSelection.forEach((val,index,val_arr)=>{
              arr.push(val.productid)
            });
            this.deleteId = arr.join(',')
          }
        }
        let params = {
          ids: this.deleteId,
        }
        if (this.key) {
          params.value = this.key
        }
        if (this.productid && this.productid.length != 0) {
          params.productid = this.productid[1].split(',')[0]
        }
        fetch({
          url: "/hcm/HcmProductAuto/deleteByBmcid",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            if (this.deleteId == 'checkAll') {
              this.checktotle = 0
            }
            this.deleteShow = false
            this.seletAutoProductPage()
          }
        });
      },
      // 删除
  		del(index,smallName) {
  			if (index || index == 0) {
  				this.selectedData.splice(index,1)
  				if (this.treeData.length != 0) {
  					for (let c in this.treeData) {
  						for (let d in this.treeData[c].checkList) {
  							if (smallName == this.treeData[c].checkList[d]) {
  								this.treeData[c].checkList.splice(d,1)
  							}
  						}
  					}
  				}
  			}
  			let Keydata = []
  			for (let a in this.selectedData) {
  				Keydata.push(this.selectedData[a].productid)
  			}
  		},
      fieldChange(index,fieldvalue) {
        this.treeData[index].fieldvalue = fieldvalue
      },
      getByProduct(index) {
        let params = {
          productClassifyid: this.classifyid,
        }
        fetch({
          url: "/hcm/hcmCustomModel/getByProduct",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.treeData[index].options = result.data.product.data
          }
        });
      },
      // 点击
  		chooseAlone(i,fieldvalue) {
        if (!fieldvalue) {
          this.$message({
            message: '请先选择关键字品名',
            type: 'warning'
          });
          return;
        }
  			let joinshow = true
  			if (this.selectedData.length != 0) {
  				for (let a in this.selectedData) {
  					if (this.selectedData[a].name === i.productClassifyNameAndProductName) {
  						joinshow = false
  						this.selectedData.splice(a,1)
  					}
  				}
  			}
  			if (joinshow) {
  				this.selectedData.push({
  					productid: i.id,
  					name: i.productClassifyNameAndProductName,
  					price: '0',
  					smallName: i.allProductName,
            productClassifyIds: i.product_classify_id,
            fieldvalue: fieldvalue,
  				})
  			}
  		},
      // 全选
  		allChange(index,childData,type,fieldvalue) {
  			if (type == 1) {
  				this.treeData[index].checkList = []
  				for (let a in childData) {
  					// if (childData[a].disableShow != true) {
  						this.treeData[index].checkList.push(childData[a].allProductName)
  					// }
  				}
  				if (this.treeData[index].checkList.length != 0) {
  					this.handleCheckChange(this.treeData,index,fieldvalue)
  				}
  			} else {
  				// 反选
  				if (this.treeData[index].checkList.length != 0) {
  					this.treeData[index].checkList.forEach(val=>{
  				    let index = this.selectedData.findIndex(item=>item.smallName === val)
  				    if(index != -1){
  			        this.selectedData.splice(index,1)
  				    }
  					})
  					this.treeData[index].checkList = []
  				}
  			}
  		},
      // 多个新增
  		insertByProduct() {
        let that = this
  			let insertHcmProductAutoList = []
        for (let a in this.selectedData) {
          insertHcmProductAutoList.push({
            fieldvalueid: this.selectedData[a].fieldvalue,
            productClassifyId: this.selectedData[a].productClassifyIds,
            productIds: this.selectedData[a].productid,
          })
        }
        axios({
           method: 'post',
           url: 'hcm/HcmProductAuto/insertByProduct',
           headers: {
             'Content-type': 'application/json;charset=UTF-8'
           },
           data: insertHcmProductAutoList,
           timeout: 60 * 1000 * 50
        }).then(function (response) {
          if (response.data.status == "10000") {
            that.$message({
              message: '保存成功',
              type: 'success'
            });
            that.visible = false
            that.seletAutoProductPage()
          } else {
            that.$message.error(response.data.message)
          }
        })
  		},
      // 单个新增
  		insert() {
        if (!this.productid2) {
          this.$message({
            message: '请选择产品名称',
            type: 'warning'
          });
          return;
        }
        let that = this
        let hcmProductAuto = {
          childList: [],
          productid: this.productid2[1].split(',')[0],
          productname: this.productid2[1].split(',')[1],
        }
        if (this.newData && this.newData.length != 0) {
          for (let a in this.newData) {
            this.newData[a].productid = this.productid2[1].split(',')[0]
            hcmProductAuto.childList.push(this.newData[a])
          }
        }
        if (this.newSkuData && this.newSkuData.length != 0) {
          for (let b in this.newSkuData) {
            if (this.newSkuData[b].alias || this.newSkuData[b].autovalue) {
              this.newSkuData[b].productid = this.productid2[1].split(',')[0]
              hcmProductAuto.childList.push(this.newSkuData[b])
            }
          }
          for (let c in hcmProductAuto.childList) {
            if (!hcmProductAuto.childList[c].autovalue && hcmProductAuto.childList[c].type != 2) {
              this.$message({
                message: '请填写正确的数据',
                type: 'warning'
              });
              return
            }
          }
        }

        axios({
           method: 'post',
           url: 'hcm/HcmProductAuto/insert',
           headers: {
             'Content-type': 'application/json;charset=UTF-8'
           },
           data: hcmProductAuto,
           timeout: 60 * 1000 * 50
        }).then(function (response) {
          if (response.data.status == "10000") {
            that.$message({
              message: '保存成功',
              type: 'success'
            });
            that.visible = false
            that.seletAutoProductPage()
          } else {
            that.$message.error(response.data.message)
          }
        })
  		},
      // 新增监控产品
      newAdd() {
        this.selectedData = []
        this.newData = []
        this.newData.push({
          type: 1,
          alias: "",
          autovalue: "",
          productid: "",
        })
        this.newSkuData = []
        this.newSkuData.push({
          type: 2,
          alias: "",
          autovalue: "",
          productid: "",
        })
        let params = {
          pageNum: 1,
          pageSize: 10000,
        }
        fetch({
          url: "hcm/ProductClassify/seletProductClassify",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.visible = true
            for (let zz in res.data.data.list) {
      				res.data.data.list[zz].elIcon = 'el-icon-caret-right'
      				res.data.data.list[zz].childData = []
              res.data.data.list[zz].checkList = []
              res.data.data.list[zz].options = []
      				res.data.data.list[zz].fieldvalue = ''
      				res.data.data.list[zz].pageSize = 500
      				res.data.data.list[zz].addMoreShow = false
      			}
      			this.pageSize = 500
      			this.visible = true
      			this.treeData = res.data.data.list
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        })
      },
      // 获取详细数据
  		getPageBybmcid(item,index,num) {
  			if (this.filterText && this.filterText != '') {
  				// 搜索不需要调用接口
  				if (item.elIcon == 'el-icon-caret-right') {
  					this.treeData[index].elIcon = 'el-icon-caret-bottom'
  				} else {
  					this.treeData[index].elIcon = 'el-icon-caret-right'
  				}
  			} else {
  				this.treeLoading = true
  				this.divLoading = true
  				if (num == 1) {
  					if (item.elIcon == 'el-icon-caret-right') {
  						this.treeData[index].elIcon = 'el-icon-caret-bottom'
  					} else {
  						this.treeData[index].elIcon = 'el-icon-caret-right'
  						this.treeData[index].addMoreShow = false
  					}
  				}
          this.classifyid = item.id
          this.getByProduct(index)
  				let params = {
  					pageNo: 1,
  					pageSize: this.pageSize,
  					classifyid: item.id,
  					type: 'tree'
  				}
  				fetch({
  					url: "hcm/hcmProduct/getPageByTree",
  					method: "get",
  					params: params,
  					noFormat: true,
  					responseType: "text"
  				}).then(result => {
  					let res = JSON.parse(result);
  					let {data}=res
  					if(res.status == '10000'){
  						this.treeData[index].childData = data.list
  						if (this.treeData[index].pageSize > data.total) {
  							this.treeData[index].addMoreShow = false
  						} else {
  							this.treeData[index].addMoreShow = true
  						}
  						this.divLoading = false
  					} else {
  						this.$message({
  							message: res.message,
  							type: "error"
  						});
  					}
  				})
  			}
  		},
      handleCheckChange(data,index,fieldvalue) {
  			if (data[index] && data[index].childData) {
  				for (let a in data[index].childData) {
  					// if (data[index].childData[a].disableShow != true) {
  						this.selectedData.push({
  							productid: data[index].childData[a].id,
  							name: data[index].childData[a].productClassifyNameAndProductName,
  							price: '0',
  							smallName: data[index].childData[a].allProductName,
                productClassifyIds: data[index].childData[a].product_classify_id,
                fieldvalue: fieldvalue,
  						})
  					// }
  				}
  			}
  			// 已选产品去重
  			var kv = {}
  			for (var i = 0; i < this.selectedData.length;) {
  				if (kv[this.selectedData[i].name + ',' + this.selectedData[i].productid]) {
  					this.selectedData.splice(i, 1)
  				} else {
  					kv[this.selectedData[i].name + ',' + this.selectedData[i].productid] = true
  					i++
  				}
  			}
      },
      seletAutoProductPage() {
        let params = {
          pageNum: this.bigPageNum,
          pageSize: this.bigPageSize,
        }
        if (this.key) {
          params.key = this.key
        }
        if (this.productid && this.productid.length != 0) {
          params.productid = this.productid[1].split(',')[0]
        }
        fetch({
          url: "/hcm/HcmProductAuto/seletAutoProductPage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.tableData = []
            this.tableData = result.data.content
            this.totalNum = result.data.totalElements
            this.allTotle = this.totalNum
          }
        });
      },
      handleChange(value) {
        this.productid = value
      },
      handleChange2(value) {
        this.productid2 = value
      },
      getListBybmcid(data) {
        if (data == true && this.options2.length == 0) {
          this.divLoading = true
          this.cascaderDisabled = true
          this.divShow = true
          fetch({
            url: "hcm/hcmProduct/getListBybmcid",
            method: "get",
            noFormat: true,
            responseType: "text"
          }).then(res => {
            let result = JSON.parse(res);
            if (result.status == "10000") {
              this.options2 = result.data;
              this.cascaderDisabled = false
              this.divShow = false
            }
          });
        }
      },
      handleSizeChange(val) {
        //每页
        this.bigPageSize = val;
        this.seletAutoProductPage()
      },
      handleCurrentChange(val) {
        //当前页
        this.bigPageNum = val;
        this.seletAutoProductPage()
      },


    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .page {
    margin: 20px 20px 10px 20px;
    background-color: white;
  }
  .page2 {
    margin: 0px 20px 10px 20px;
    background-color: white;
    padding: 20px;
  }
  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-top: 8px;
    margin-bottom: 8px;
  }
  .promptFont{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .promptFont2{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
  }
</style>
<style lang="scss">
#automaticMarking {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
  .ellipsisFont {
		float: left;
		width: 400px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		height: 24px;
		line-height: 24px;
	}
  .selSty {
		padding: 0 11px;
		height: 32px;
		line-height: 32px;
	}
	.selSty:hover {
		background-color: #f6f7fb;
	}
  .header{
		padding: 0 0 0 10px;
		line-height: 40px;
		margin: 0;
		background-color: #f6f7fb;
	}
	.divBor {
		height: 565px;
		margin: 10px 0;
		border: 1px solid rgb(217, 217, 217);
	}
	.allDiv {
		float: left;
		width: 459px;
		height: 565px;
		border-right: 1px solid rgb(217, 217, 217);
	}
	.smDiv{
		float: right;
		width: 458px;
		height: 565px
	}
  .buttonStyle {
    i {
      cursor: pointer;
      height: 32px;
      line-height: 32px;
      color: #409eff;
    }
    clear: both;
    cursor: pointer;
    width: 331px;
    border: 1px dashed #409eff;
    text-align: center;
    border-radius: 5px;
    height: 32px;
    float: left;
    margin-left: 70px;
  }
  .marginStyle {
    width: 150px;
    text-align: center;
    float: left;
    margin-top: 16px;
  }
}
</style>
